<template>
  <section>
    <v-parallax src="@/assets/image/dev1.png" height="600">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="9" xl="9">
              <h1 class="h1-title mt-15">Получите<br> налоговый вычет</h1>
              <h1 class="h2-title">
                Оставьте заявку онлайн<br/>
                и получите налоговый вычет.<br/> Гарантия качества услуг. <br/>
                Оплата по факту.
              </h1>
              <v-btn large
                     class="call-btn-2"
                     @click="$vuetify.goTo('#request')"
              >
                Получить налоговый вычет
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img :eager="true" src="@/assets/img/borderWaves.svg"/>
      </div>
    </v-parallax>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.call-btn-2 {
  margin-top: 30px;
  background-color: #c42234 !important;
  color: white !important;
}

.h1-title {
  font-size: 42px;
  color: #505050;
  font-weight: 400;
  line-height: 1.0;
}

.h2-title {
  padding-top: 30px;
  font-size: 26px;
  color: #505050;
  font-weight: 400;
  line-height: 1;
}

::v-deep .v-parallax__image {
  //transform: translate(-45%, 120px) !important;
  //height: 600px;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

section {
  position: relative;
}

@media (max-width: 500px) {
  ::v-deep .v-parallax__image {
    left: 100% !important;
  }

  .h1-title {
    font-size: 32px;
    color: #505050;
    font-weight: 400;
    line-height: 1.0;
  }

  .h2-title {
    padding-top: 30px;
    font-size: 18px;
    color: #505050;
    font-weight: 400;
    line-height: 1;
  }
}
</style>
